import styled from 'styled-components';
import { AnalysisStatus } from '../../utils/apollo/graphqlSchema';

interface IProps {
  status: AnalysisStatus;
}

const Container = styled.span`
  flex: 0 0 auto;
  display: inline-block;
  margin-right: 4px;
  padding-right: 4px;
  padding-left: 4px;
  border-radius: 2px;
  text-transform: uppercase;
  font-size: 8px;
  font-weight: 600;
  line-height: 1.5;
  color: #fff;
`;

const ReportStatusBadge = ({ status }: IProps) => {
  if (status === AnalysisStatus.Cancelled) {
    return (
      <Container style={{ backgroundColor: '#ed65a3' }}>Cancelled</Container>
    );
  }

  if (status === AnalysisStatus.Failed) {
    return <Container style={{ backgroundColor: '#b2000c' }}>Failed</Container>;
  }

  if (status === AnalysisStatus.Pending || status === AnalysisStatus.Running) {
    return (
      <Container style={{ backgroundColor: '#45b5c6' }}>Running</Container>
    );
  }

  return null;
};

export default ReportStatusBadge;
